import React from 'react';
import { AuditProvider } from './LegalContext';
import AuditPage from './LegalPage';
import { AuditPageProps } from './types';

/**
 * Container component for the legal virtual agent system.
 * Wraps the page content with the context provider.
 */
const AuditContainer: React.FC<AuditPageProps> = props => {
  return (
    <AuditProvider>
      <AuditPage {...props} />
    </AuditProvider>
  );
};

export default AuditContainer;
